import React, { memo } from 'react';
import './PowerStatusMessage.scss';

function PowerStatusMessage(props) {
    const { message, imgIcon, view, showUploadPrescModal, dataLocale } = props;
    return (
        <div data-testid="powerStatusMessage" className={`power-status-message display-flex align-items-center ${view === 'desktop' ? 'desktop padding-12 margin-l15 margin-b10 margin-t10 bora-8' : 'pd-12 bora-4 mr-auto'}`}>
            <div className="status-icon mr-r12 margin-r12" id={imgIcon}>
                <span className="icon display-flex align-items-center test-color_white justify-content-center fsp18 fs18">
                    <img aria-label="Power Status Icon" src={imgIcon} alt="Power status icon" />
                </span>
            </div>
            <div className="status-message fsp12 fs14 lh-16 display-flex align-items-center flex-1">{message}</div>
            {typeof showUploadPrescModal === 'function' && <div className={`${view === 'desktop' ? 'text-color-primary cursor-pointer margin-r20 uppercase' : 'mr-l8 fs14 text-color_link_blue text-uppercase'} fw700 align-self-center`} onClick={showUploadPrescModal}>{dataLocale?.VIEW_DETAILS}</div>}
        </div>
    );
}

export default memo(PowerStatusMessage);
